import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedUploadURLForClientLogoRPC } from "./getPresignedUploadUrlForClientLogoRPC";

export class GetPresignedUploadURLForClientLogoRPCClientImpl extends GetPresignedUploadURLForClientLogoRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedUploadURLForClientLogoRPC.Request): Promise<LeoRPCResult<GetPresignedUploadURLForClientLogoRPC.Response, GetPresignedUploadURLForClientLogoRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/GetPresignedUploadURLForClientLogo",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedUploadURLForClientLogoRPC.ResponseDTO,
      GetPresignedUploadURLForClientLogoRPC.Errors.ErrorsDTO,
      GetPresignedUploadURLForClientLogoRPC.Response,
      GetPresignedUploadURLForClientLogoRPC.Errors.Errors
    >(
      response,
      "survey/GetPresignedUploadURLForClientLogo",
      GetPresignedUploadURLForClientLogoRPC.Response.fromDTO,
      GetPresignedUploadURLForClientLogoRPC.Errors.fromDTO
    );
  }
}
